import { css } from '@emotion/css';
import {NavWidgetContents} from 'Shared/frontend/nav/NavWidgetContents';
import { sanitise } from 'Shared/common/Sanitise';
import { Show, createSignal, onMount } from 'solid-js';
import { StandardNavWithLogo as StandardNavWithLogoSchema } from 'Shared/frontend/nav/navSchema';
import { ImageDetails } from 'Shared/model/basic';
import { useUrls } from 'Shared/SiteProvider';
import { theme } from 'Shared/frontend/SettingsProvider';
import { useAtTop, useStyleDetails } from 'Shared/frontend/widgets/StylesProvider';
import { resolveNavStyles } from 'Shared/frontend/widgets/Styles';

export const stickyStyle = () => ({
	position: 'sticky',
	overflow: 'visible',
	top: 0,
	left: 0,
	right: 0,
//		zIndex: 11,
	zIndex: 10,
});


export function StandardNavWithLogo(P:{logo:ImageDetails})
{
	const desktop = () => theme().nav.desktop as StandardNavWithLogoSchema;
	const settings = () => desktop().settings;
	const logoSide = () => settings().logoPosition;

	const atTop = useAtTop();
	const styleDetails = useStyleDetails();
	const navStyles = () => resolveNavStyles(styleDetails(), atTop());

	const [mounted, setMounted] = createSignal(false);
	onMount(() => setMounted(true));

	//XXX sticky sub navs are layed over this - bodgy: requires subnav to be at least as tall
	const outerStyle = () => css({
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
		},
		settings().sticky ? stickyStyle() : {},
		settings().outer,
		navStyles().css
	);

	const innerStyle = () => css({
			...sanitise.button,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		settings().inner
	);

	const logoUrl = () => {
		if (!P.logo?.hash) return '';
		return useUrls().createImageUrl(P.logo.hash,P.logo,'Venue-logo','full');
	};

	return (
		<Show when={!mounted() || !navStyles().hide}>
			<nav class={outerStyle()} >
				<div class={innerStyle()}>
					<Show when={logoSide()=='left'}>
						<img class={css(settings().logo)} src={logoUrl()} />
					</Show>

					<NavWidgetContents logo={P.logo} />

					<Show when={logoSide()=='right'}>
						<img class={css(settings().logo)} src={logoUrl()} />
					</Show>
				</div>
			</nav>
		</Show>
	);
}

